import { Button, Form, Input, Message, Tabs } from "@arco-design/web-react";
import React, { useEffect, useState } from "react";
import "./index.less";
import loginLogo from "@/assets/images/login-logo.png";
import loginBg from "@/assets/images/login-bg.png";
import TabPane from "@arco-design/web-react/es/Tabs/tab-pane";
import loginDesc from "@/assets/images/login-desc.png";
import UserLogin from "./component/UserLogin";
import AgentLogin from "./component/AgentLogin";
import AgentList from "@/components/AgentList";
import { observer } from "mobx-react-lite";
import AgentStore from "@/stores/agentLogin";
import { agentOneLogin } from "@/services/login";
import star from "@/assets/images/star.png";
import textfoolt from "@/assets/images/textfoolt3.png";
import textfoolt2 from "@/assets/images/textfoolt4.png";
import yunshi_banner from "@/assets/images/yunshi_banner.png";
import yunshi_logo from "@/assets/images/login_logo.png";
import minimize from "@/assets/images/minimize.png";
import zoom_max from "@/assets/images/zoom_max.png";
import zoom_min from "@/assets/images/zoom_min.png";
import close from "@/assets/images/close.png";
import { useNavigate, useSearchParams } from "react-router-dom";

function Index() {
  const [activeTab, setActiveTab] = useState("0");
  const navigate = useNavigate();
  const [agentInfo, setAgentInfo] = useState<any>();
  const [isMaximized, setIsMaximized] = useState(false);

  const checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };
  const handleMinimize = () => {
    window.electron.ipcRenderer.windowControl.minimize();
  };

  const handleMaximize = () => {
    window.electron.ipcRenderer.windowControl.maximize();
  };

  const handleClose = () => {
    window.electron.ipcRenderer.windowControl.close();
  };
  const [search] = useSearchParams();
  const adminToken = search.get("token");
  useEffect(() => {
    if (adminToken) {
      window.localStorage.clear();
      window.localStorage.setItem("Token", adminToken);
      navigate("/matrix");
    }
  }, [adminToken]);
  return (
    <div className="matrix-login">
      {window && window.electron ? (
        <div
          className="clent-tool"
          style={{ display: checkAppleSystem() ? "none" : "flex" }}
        >
          <div onClick={handleMinimize}>
            <img src={minimize} alt="" />
          </div>
          <div onClick={handleMaximize}>
            <img src={isMaximized ? zoom_min : zoom_max} alt="" />
          </div>
          <div onClick={handleClose}>
            <img src={close} alt="" />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="left">
        <img
          className="login-logo"
          src={AgentStore?.appConfig?.web?.app?.transparent_logo}
          alt=""
        />
        <div className="item_img_contel">
          <img
            alt="banner-image"
            className="animate__animated animate__zoomIn"
            style={{ width: "85%" }}
            src={yunshi_banner}
          />
          <img className="star_image" src={star} width={50} />
          <img
            className="textfoolt  banner_textfoolt_image animate__animated animate__bounce"
            src={textfoolt}
            style={{ width: "50%" }}
          />
          <img
            className="textfoolt  banner_textfoolt_image animate__animated animate__fadeIn"
            src={textfoolt2}
          />
        </div>
      </div>
      <div className="right">
        <div className="login-form">
          <Tabs
            activeTab={activeTab}
            onChange={(e) => {
              setActiveTab(e);
            }}
            className="login-tab"
          >
            <TabPane key="0" title="用户登录">
              <UserLogin />
            </TabPane>
            {/* <TabPane key="1" title="代理商登录">
              {AgentStore.agent_info &&
              Object.keys(AgentStore.agent_info).length ? (
                <div className="agent-login">
                  <AgentList
                    clear
                    handleChange={(row) => {
                      AgentStore.setAgentTeamId(row.id);
                      setAgentInfo(row);
                    }}
                  />
                  <Button
                    type="primary"
                    disabled={!agentInfo?.uuid}
                    onClick={async () => {
                      const res = await agentOneLogin({
                        uuid: agentInfo?.uuid,
                      });
                      console.log(res);
                      if (res.code === 0) {
                        localStorage.setItem(
                          "agent_token",
                          AgentStore.agent_info.token
                        );
                        localStorage.setItem("Token", res.data.token);
                        navigate("/matrix");
                      }
                    }}
                  >
                    登录
                  </Button>
                </div>
              ) : (
                <AgentLogin />
              )}
            </TabPane> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
export default observer(Index);
